import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching user's reviews
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useReviewsQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["reviews", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/reviews");
      return res.data.reviews || [];
    },
    enabled: enabled && !!userId,
  });
};
